export const RoundCheckMarkWhite = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.33325" cy="9" r="9" fill="white" />
      <path
        d="M5.33325 8.94545L8.1777 12L13.3333 6"
        stroke="#0C0C0E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
